var EditionInfoDto = /** @class */ (function () {
    function EditionInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionInfoDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.trialDayCount = data["trialDayCount"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.isHighestEdition = data["isHighestEdition"];
            this.isFree = data["isFree"];
            this.id = data["id"];
        }
    };
    EditionInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionInfoDto();
        result.init(data);
        return result;
    };
    EditionInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data;
    };
    EditionInfoDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new EditionInfoDto();
        result.init(json);
        return result;
    };
    return EditionInfoDto;
}());
export { EditionInfoDto };
